import { render } from "./DonutChart.vue?vue&type=template&id=5f98425d&scoped=true"
import script from "./DonutChart.vue?vue&type=script&lang=js"
export * from "./DonutChart.vue?vue&type=script&lang=js"

import "./DonutChart.vue?vue&type=style&index=0&id=5f98425d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f98425d"],['__file',"src/components/chart/DonutChart.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5f98425d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5f98425d', __exports__)) {
    api.reload('5f98425d', __exports__)
  }
  
  module.hot.accept("./DonutChart.vue?vue&type=template&id=5f98425d&scoped=true", () => {
    api.rerender('5f98425d', render)
  })

}


export default __exports__